// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1175":"PrototypeViewer","1628":"livekit-egress-template"}[chunkId] || chunkId) + "." + {"1175":"467b2178e4e232165850","1235":"9406daaca72d57c782d8","1628":"b8db09b550a9f97a1399","7250":"9b53117401688c18fed6","7412":"467b2178e4e232165850","8886":"b596de00558145c4d640"}[chunkId] + ".chunk.css";
};